import React, { useState } from 'react'
import DateTimeClock from '../DateTimeClock/DateTimeClock';
import moment from "moment";
import { useDispatch, useSelector } from 'react-redux';
import { fetchRentalPrice } from "../../store/booking/operations";
import { Translate } from "react-redux-i18n";
import LoadingIndicator from "../LoadingIndicator";
import { Button } from "@blueprintjs/core";
import { isFetchingRentalPrice, getRentalPrice } from "../../store/booking/selectors";
import FormattedPrice from "../FormatedPrice";
import { MAX_RENTAL_INTERVAL } from '../../config'

export default function ProductRentalForm({ circleId, selected_date, saving_booking, saveBooking }) {
    const [clock, setClockState] = useState({
        start_date: undefined,
        end_date: undefined,
    });
    const dispatch = useDispatch();
    const fetching_price = useSelector(isFetchingRentalPrice);
    const rental_price = useSelector(getRentalPrice);

    const onClockUpdate = ({ start_date, end_date }) => {
        setClockState({ start_date, end_date });
        const startDate = moment(start_date);
        const endDate = moment(end_date);

        const hours = endDate.diff(startDate, 'hours', true);
        if (hours <= 0) return;
        dispatch(fetchRentalPrice(circleId, Math.round(hours)));
    }
    const handleSave = () => {
        if (!clock.start_date || !clock.end_date) return;
        saveBooking([moment(clock.start_date), moment(clock.end_date)]);
    }

    return (
        <div className="dialog-wrapper">
            <div className="booking-details-form">
                <DateTimeClock
                    selected_date={selected_date}
                    onUpdate={onClockUpdate}
                    maxInterval={MAX_RENTAL_INTERVAL}
                />
                <div className="rental-price">
                    <Translate value="rental.rental_price" />
                    &nbsp;
                    {fetching_price && <LoadingIndicator size={20} />}
                    {!fetching_price && rental_price && <strong>
                        <FormattedPrice
                            value={rental_price.value}
                            currency_type={rental_price.currency}
                        />
                    </strong>
                    }
                </div>
                <Button
                    intent="primary"
                    fill={true}
                    disabled={saving_booking}
                    onClick={handleSave}
                    className="save-booking-cta">
                    {!saving_booking && <Translate value="booking.save_booking" />}
                    {saving_booking && <LoadingIndicator />}
                </Button>
            </div>
        </div>
    )
}
